module.exports = __webpack_public_path__ + "img/empty.41b3db0b.png";